export function displayableDataToViewData(data) {
    const ret = {};
    data.data.forEach((field) => {
        ret[field.name] = field.data;
    });
    if (data._attachments) {
        Object.getOwnPropertyNames(data._attachments).forEach((attachment) => {
            // this 2nd check shouldn't be necessary, but TS is insisting
            if (data._attachments) {
                ret[attachment] = data._attachments[attachment].data;
            }
        });
    }
    return ret;
}
//# sourceMappingURL=ViewData.js.map